import { all, call, fork, put, takeEvery } from "redux-saga/effects";

//Account Redux states
import { RESET_PASSWORD } from "./actionTypes";
import { reserPasswordFailed, reserPasswordSuccessful } from "./actions";

import {
  postFakeRegister,
  postResetPassword,
} from "../../../helpers/fakebackend_helper";

//restapi end point
import * as constClass from "../../../common/constant/constantURL";

// Is user register successfull then direct plot user in redux.
function* resetPassword({ payload: { user } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      var url = constClass.REST_API_RESET_PASSWORD_VERIFY_CODE;

      const myKey = "code";
      const myObject = {
        [myKey]: user,
      };

      //calling  api for verify reset password link
      const response = yield call(postResetPassword, url, myObject);

      yield put(reserPasswordSuccessful(response));
      localStorage.setItem("authUser", JSON.stringify(response));
      localStorage.setItem("isAuthProtected", true);
      localStorage.setItem("setpassword", true);
    } else if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
      const response = yield call(postFakeRegister, user);
      yield put(reserPasswordSuccessful(response));
    }
  } catch (error) {
    localStorage.setItem("isAuthProtected", false);
    yield put(reserPasswordFailed(error));
  }
}

export function* watchUserRegister() {
  yield takeEvery(RESET_PASSWORD, resetPassword);
}

function* resetPasswordSaga() {
  yield all([fork(watchUserRegister)]);
}

export default resetPasswordSaga;
